import React from 'react';
import { Link as GatsbyLink } from 'gatsby';
import { isExternalLink, isSpecialLink } from '../utils/helpers';

const Link = ({ acfLink, to, children, ...other}) => {
  let theUrl = acfLink?.url || to || '#';

  let envDomains = [
    'http://localhost:8000',
    'https://lencosupplies.gatsbyjs.io/',
    'https://lencoonline.com/',
    'https://lencosupplies.net',
    'https://lenco.supplies'
  ];

  envDomains.every(domain => {
    if(theUrl.includes(domain)) {
      theUrl = theUrl.replace(domain, '');
      return false;
    }
    return true;
  })

  if(!theUrl) {
    theUrl = '/'
  }

  const external = isExternalLink(theUrl);
  let theAction = null;
  const theChildren = children || acfLink?.title;

  // If url has a mapped action, return a button with the action onClick
  if(theAction) {
    return (
      <button onClick={theAction} {...other}>
        {theChildren}
      </button>
    )
  }

  /**
   * mailto:, sms:, or tel:
   */
   if(isSpecialLink(theUrl)) {
    return (
      <a href={theUrl} {...other}>
        {theChildren}
      </a>
    )
  }

  if(external) {
    return (
      <a href={theUrl} target="_blank" rel="noopener noreferrer" {...other}>
        {theChildren}
      </a>
    )
  }

  // In all other cases, it should be safe to return a gatsby link
  return (
    <GatsbyLink to={theUrl} {...other}>
      {theChildren}
    </GatsbyLink>
  )
}

export default Link;
